import { Component, OnInit } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ServiceCookie } from 'app/shared/services/cookie.service';
import { environment } from 'environments/environment';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
  appVersion: string = environment.appVersion;
  customerName: string = localStorage.getItem('customerName');

  year = new Date().getFullYear();
  constructor() { }

  ngOnInit() {}

}
